module.exports = __webpack_public_path__ + "static/media/RadomirLogo.cfde85fd.png";